import React from 'react';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import useStyles from './styles';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import useQuery from 'custom_hooks/useQuery';
import MessageIncomingActions from '../../../../redux/reducers/message_incoming_reducer/actions';
import { ReducerKeys } from '../../../../redux/reducers';
import { getState } from 'redux/store';
import { StateStatus } from '../../../../redux/utils/common';
interface IProps {
  rowIndex: number;
  registration_id: string;
  error: string;
  incoming_message_id: string | number;
}

export default function ActionsBlock(props: IProps) {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  // const query = useQuery();
  // const queryString =
  //   query && query.toString().length > 0 ? `?${query.toString()}` : '';
  // const vat_num = query.get('vat_num');
  // const msidCountry = query.get('msidCountry');
  // const schemeType = query.get('schemeType');
  // let searchParams = {
  //   ...(vat_num && { vat_num }),
  //   ...(msidCountry && { msidCountry }),
  //   ...(schemeType && { schemeType }),
  // };
  // console.log(searchParams);
  // console.log('>> ', query.toString());
  // let query = [];
  // if (data.vat_num)
  //   query.push({
  //     key: 'vat_num',
  //     value: data.vat_num,
  //   });
  // if (data.msidCountry)
  //   query.push({
  //     key: 'msidCountry',
  //     value: data.msidCountry,
  //   });
  // if (data.schemeType)
  //   query.push({
  //     key: 'schemeType',
  //     value: data.schemeType,
  //   });
  // let queryString = '';
  // query.map((query, index) => {
  //   if (index == 0) queryString += `?${query.key}=${query.value}`;
  //   else queryString += `&${query.key}=${query.value}`;
  // });

  const viewRegistrationReceived = () => {
    history.push(
      NavigationConfig.registrationReceivedDetailPage(props.registration_id)
        .path
    );
  };

  const handleClick = async (type: 'view' | 'error') => {
    let header = type === 'view' ? 'XML Content' : 'XML Error';
    let body = type === 'view' ? props.incoming_message_id : props.error;

    if (type === 'view') {
      await dispatch(
        MessageIncomingActions.fetchMessageIncomingXmlAction({
          messageId: `${props.incoming_message_id}`,
        })
      );
      const xmlMessage = getState(
        ReducerKeys.MESSAGE_INCOMING_REDUCER
      ).xmlMessage;
      // console.log(xmlMessage);
      if (
        xmlMessage.status === StateStatus.Success &&
        xmlMessage.data !== null
      ) {
        body = xmlMessage.data;
      } else {
        body = `XML of Incoming Message with ID: ${props.incoming_message_id} not found`;
      }
    }

    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_REGISTRATION_RECEIVED_VIEW,
        params: { header, body },
      })
    );
  };

  return (
    <React.Fragment>
      <Button
        style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
        // disabled={paymentAllocationStatus === StateStatus.Pending}
        onClick={viewRegistrationReceived}
      >
        Details
      </Button>
      {props.incoming_message_id && (
        <Button
          style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
          // variant="outlined"
          // className={classes.viewButton}
          onClick={() => handleClick('view')}
        >
          XML
        </Button>
      )}
      {props.error && (
        <Button
          style={{ marginTop: '.25rem', marginBottom: '.25rem' }}
          // variant="outlined"
          // className={classes.viewButton}
          className={classes.textRedColor}
          onClick={() => handleClick('error')}
        >
          Error
        </Button>
      )}
    </React.Fragment>
  );
}
